import { Input, Optional, Directive } from '@angular/core';
import { DialogContainerComponent } from './dialog-container.component';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ElementsModule } from '@shared/elements/elements.module';
/* eslint-disable */

// Counter for unique dialog ids.
let uniqueId = 0;

/**
 * Title of a dialog element. Stays fixed to the top of the dialog when scrolling.
 */
@Directive({
    selector: 'pay-dialog-title',
    standalone: true,
    host: {
        class: 'c-dialog__title',
        '[id]': 'id',
    },
})
export class DialogTitleComponent {
    @Input() id = `pay-dialog-title-${uniqueId++}`;

    constructor(@Optional() private container: DialogContainerComponent) {}
}
